import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { ChangeTemplateSourceForm } from './ChangeTemplateSourceForm'

export const ChangeTemplateSourceNestedCommand = ({
  employerAgreementId,
  ...props
}: ActionButtonProps & { employerAgreementId: string }) => {
  const translate = useTranslate()
  const tenantId = useHook('routing.tenant.useTenantParam')()

  const actions = useHook(
    'mutators.life.useChangeTemplateSourceCommandActions',
  )({
    tenantId,
    employerAgreementId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.ChangeTemplateSourceCommandData"
      title={translate('changeTemplateSourceCommand.title')}
      commandDataForm={ChangeTemplateSourceForm}
      submit={submit}
      {...props}
    />
  )
}
